import classNames from 'classnames';
import { observer } from 'mobx-react-lite';
import { FC, MouseEventHandler } from 'react';

import { IcDelete16Icon } from '@gem/icons';
import { useTranslation } from '@gem/modules/i18n';
import { IconView, IconViewSizes } from '@gem/ui-kit';

import { MiniatureMessageLayout } from 'APP/main/ChatView/components/MiniatureMessageLayout/MiniatureMessageLayout';
import { ChatMessage } from 'APP/store/Messages/Message/ChatMessage/ChatMessage';

import styles from './DeletedByMePayload.styles.m.scss';

interface IDeletedByPayloadProps {
  titleClassName?: string;
  textClassName?: string;
  iconClassName?: string;
  message: ChatMessage;
  title: string;
  preventInteraction?: boolean;
  onClick?: MouseEventHandler;
}

export const DeletedByMePayload: FC<IDeletedByPayloadProps> = observer(
  ({
    titleClassName,
    textClassName,
    iconClassName,
    message,
    title,
    onClick,
    preventInteraction,
  }) => {
    const { t } = useTranslation();

    return (
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      <MiniatureMessageLayout
        titleClassName={titleClassName}
        iconClassName={iconClassName}
        title={title}
        messageId={message.id}
        onClick={onClick}
        preventInteraction={preventInteraction}
      >
        <div className={classNames(styles.text, textClassName)}>
          <IconView
            Icon={IcDelete16Icon}
            className={styles.icon}
            size={IconViewSizes.Small}
          />
          {t('common_message_deleted')}
        </div>
      </MiniatureMessageLayout>
    );
  }
);
